<template>
    <div class="content">
        <div id="print">
            <title>打印入库单</title>
            <div style=" position: relative;z-index: 1;margin-top: 50px;">
                <div id="qrcode" style="bottom:0; right: 0;width: 90px;height: 90px;position: absolute;z-index: 3;">
                </div>
                <h1 style=" text-align: center;margin-bottom: 20px !important;margin-top: 20px;font-weight: bold;font-size: 26px">入库单</h1>
                <div style="color: #666;font-size: 13px;margin-top: 40px;margin-bottom: 20px">入库单号：<span
                        style="color: #d9534f;margin-right: 30px">{{data.stock_in_sn}}</span>入库时间：<span
                        style="color: #d9534f;margin-right: 30px">{{data.created_at}}</span></div>
            </div>
                <div>
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style=" border-collapse: collapse;">
                        <thead>
                        <tr>
                            <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;width: 100px;">生产批次号</th>
                            <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">产品编号</th>
                            <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">产品名称</th>
                            <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">规格</th>
                            <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;width: 100px;" >数量</th>
                            <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;width: 100px;">包装类型</th>
                            <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;width: 140px;">生产日期</th>
                        </tr>

                        </thead>
                        <tbody>
                        <tr>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{data.production_batch}}</td>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{data.product_sn}}</td>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{data.product_name}}</td>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{data.product_specs}}</td>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{data.stock_in_num}}</td>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{data.product_unit}}</td>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">{{data.production_date}}</td>
                        </tr>
                        <tr>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;">备注</td>
                            <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 30px;" colspan="6"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        <div style="position: absolute;-webkit-transform: translateX(-50%);-moz-transform: translateX(-50%);-ms-transform: translateX(-50%);-o-transform: translateX(-50%);
        transform: translateX(-50%);left:50%;margin-top: 20px">
            <el-button size="mini" @click="myPrint()">打印</el-button>
            <el-button size="mini" @click="close()">关闭</el-button>
        </div>
    </div>
</template>
<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "print-instock",
        data() {
            return {
                data:{}

            }
        },
        methods: {
            getData(){
                let str = this.$route.query.stock_in_sn,
                url = '/inwarehouses/' + str;
                this.$get('logistics',url, {
                }).then(res => {
                    this.data = res.data;
                }).catch(function (error) {
                    console.log(error);
                });

            },
            //打印
            myPrint() {
                let obj = document.getElementById('print');
                var newWindow = window.open("打印窗口", "_blank");
                var docStr = obj.innerHTML;
                newWindow.document.write(docStr);
                newWindow.document.close();
                newWindow.print();
                newWindow.close();
            },
            //返回上一页
            close(){
               this.$router.push({
                   name:'instockManage'
               });
            },
            //二维码
            //扫码
            qrcode () {
                let qrcode = new QRCode('qrcode', {
                    width: 90,
                    height: 90, // 高度
                    text:  this.$route.query.stock_in_sn
                })
            },
        },
        created() {
            this.getData();
            this.$nextTick(function () {
                this.qrcode();
            })

        },
    }
</script>
<style lang="scss" scoped>
    .container {
        padding: 20px;
        position: relative;

    }

</style>
